import React from 'react';
import classNames from 'classnames';
import styles from './Text.module.scss';
/**
 * Drop-in replacement for `Text` from `wix-ui-tpa/cssVars`.
 *
 * Note this package's own `TextExtended` wrapper is the usual way text is rendered here;
 * WUT's `Text` is used directly in only one place.
 */
export const Text = ({ className, children, ...rest }) => {
    return (React.createElement("span", { ...rest, className: classNames(styles.root, className) }, children));
};
//# sourceMappingURL=Text.js.map